import styled from 'styled-components'

export const RootS = styled.div`
  width: 100%;
  min-height: 100vh;

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  padding: ${({ theme }) => theme.metrics.space5};

  border-top: 6px solid ${({ theme }) => theme.colors.primary};
`

export const CardS = styled.div`
  width: 480px;
  max-width: 100%;

  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  padding: ${({ theme }) => theme.metrics.space6};

  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.metrics.radius};
  box-shadow: 0 3px 6px #00000016;
`

export const ScopesS = styled.ul`
  width: 100%;
  margin: 0;
  padding: ${({ theme }) => theme.metrics.space5};
  list-style: none;

  background-color: ${({ theme }) => theme.colors.gray20};
  border-radius: ${({ theme }) => theme.metrics.radius};

  li {
    display: flex;
    align-items: flex-start;
    gap: ${({ theme }) => theme.metrics.space2};
  }

  li + li {
    margin-top: ${({ theme }) => theme.metrics.space4};
  }
`
